export const navData = [
    {
        label: '为什么选择羿畅',
        page: 'choiceYC',
        msg: `人生在勤，勤则不匮`,
        showChildren: false,
        show: true,
        images: ['choiceYC.png', 'prescription.png', 'newsMedia.png'],
        children: [
            { label: '成功案例', page: 'successCase', p_page: 'choiceYC' },
            { label: '产品优势', page: 'productAdvantage', p_page: 'choiceYC' },
            { label: '技术优势', page: 'technicalAdvantage', p_page: 'choiceYC' },
            { label: '服务优势', page: 'serviceAdvantage', p_page: 'choiceYC' }
        ]
    },
    {
        label: '解决方案',
        page: 'prescription',
        msg: '志之所趋，无远弗届',
        showChildren: false,
        show: true,
        images: ['aboutYC.png', 'obligationYC.png', 'joinUs.png'],
        children: [
            { label: '高速公路养护管理系统', page: 'freewayMaintain', p_page: 'prescription' },
            { label: '高速公路养护决策分析系统', page: 'freewayDecision', p_page: 'prescription' },
            { label: '普通公路养护管理系统', page: 'normalRoadMaintain', p_page: 'prescription' },
            { label: '农村公路大数据云平台', page: 'ruralRoadBigData', p_page: 'prescription' },
            { label: '道路AI智能养护巡查系统', page: 'roadAIMaintain', p_page: 'prescription' },
            { label: '农村公路自动化检测服务', page: 'ruralRoadAutoDetection', p_page: 'prescription' }
        ]
    },
    {
        label: '新闻与媒体',
        page: 'newsMedia',
        msg: '积土而为山，积水而为海',
        showChildren: false,
        show: true,
        images: ['freewayMaintain_bg.png', 'freewayDecision_bg.png', 'normalRoadMaintain_bg.png'],
        children: []
    },
    {
        label: '关于羿畅',
        page: 'aboutYC',
        msg: `千磨万击还坚劲，任尔东南西北风`,
        showChildren: false,
        show: true,
        images: ['ruralRoadBigData_bg.png', 'roadAIMaintain_bg.png', 'ruralRoadAutoDetection_bg.png'],
        children: []
    },
    {
        label: '羿畅责任',
        page: 'obligationYC',
        msg: `芳林新叶催陈叶，流水前波让后波`,
        showChildren: false,
        show: true,
        images: ['choiceYC.png', 'prescription.png', 'newsMedia.png'],
        children: []
    },
    {
        label: '服务与升级',
        page: 'serviceUpgrade',
        msg: '服务与升级',
        showChildren: false,
        children: [],
        images: ['aboutYC.png', 'obligationYC.png', 'joinUs.png'],
        show: false
    },
    {
        label: '合作伙伴',
        page: 'joinUs',
        msg: `<p style="text-align: center">羿畅“数字交通”生态「共创」计划</p>`,
        showChildren: false,
        children: [],
        images: ['choiceYC.png', 'prescription.png', 'newsMedia.png'],
        show: true
    }
];

export const linkData = [
    {
        label: '为什么选择羿畅',
        page: 'choiceYC',
        children: [
            { name: '成功案例', page: 'successCase', p_page: 'choiceYC' },
            { name: '产品优势', page: 'productAdvantage', p_page: 'choiceYC' },
            { name: '技术优势', page: 'technicalAdvantage', p_page: 'choiceYC' },
            { name: '服务优势', page: 'serviceAdvantage', p_page: 'choiceYC' },
        ]
    },
    {
        label: '解决方案',
        page: 'prescription',
        children: [
            { name: '高速公路养护管理系统', page: 'freewayMaintain', p_page: 'prescription' },
            { name: '高速公路养护决策分析系统', page: 'freewayDecision', p_page: 'prescription' },
            { name: '普通公路养护管理系统', page: 'normalRoadMaintain', p_page: 'prescription' },
            { name: '农村公路大数据云平台', page: 'ruralRoadBigData', p_page: 'prescription' },
            { name: '道路AI智能养护巡查系统', page: 'roadAIMaintain', p_page: 'prescription' },
            { name: '农村公路自动化检测服务', page: 'ruralRoadAutoDetection', p_page: 'prescription' },
        ]
    },
    {
        label: '新闻与媒体',
        page: 'newsMedia',
        children: [
            { name: '新闻', page: 'newsMedia', p_page: 'newsMedia' },
            { name: '媒体', page: 'newsMedia', p_page: 'newsMedia' },
        ]
    },
    {
        label: '关于羿畅',
        page: 'aboutYC',
        children: [
            { name: '概况', page: 'aboutYC', p_page: 'aboutYC' },
        ]
    },
    {
        label: '羿畅责任',
        page: 'obligationYC',
        children: [
            { name: '客户责任', page: 'obligationYC', p_page: 'obligationYC' },
            { name: '社会责任', page: 'obligationYC', p_page: 'obligationYC' },
            { name: '员工责任', page: 'obligationYC', p_page: 'obligationYC' },
        ]
    },
];
